import Flash from "lib/flash"
import { Controller } from "@hotwired/stimulus"

// PATCHes a preferences checkbox's change, rolling the checkbox back and
// showing an alert if the update fails.
export default class PreferencesCheckboxController extends Controller {
  static values = {
    updatePath: String,
    key: String,
    defaultErrorMessage: String,
  }

  // Cancels clicks while an update is pending, so a failed update can't roll
  // back over a later one, and updates reach Braze in order. Cancelling the
  // click stops the toggle, so no change event fires; Space on a focused
  // checkbox also arrives as a click.
  guard(event) {
    if (this.pending) event.preventDefault()
  }

  async change(event) {
    const checkbox = event.target
    const checked = checkbox.checked

    // Keep the checkbox enabled while pending, as disabling it would drop
    // keyboard focus
    this.pending = true
    checkbox.setAttribute("aria-busy", "true")

    const result = await this.update(checked)

    checkbox.removeAttribute("aria-busy")
    this.pending = false

    if (result.ok) {
      Flash.now("notice", result.message)
    } else {
      checkbox.checked = !checked
      Flash.now("alert", result.errors?.[0] || this.defaultErrorMessageValue)
    }
  }

  async update(checked) {
    try {
      const response = await fetch(this.updatePathValue, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        },
        body: JSON.stringify({
          preferences: { [this.keyValue]: checked },
        }),
      })

      const { message, errors } = await response.json()

      return { ok: response.ok, message, errors }
    } catch {
      return { ok: false }
    }
  }
}
